import React, {ReactNode} from 'react'
import {StyledReservationStatus} from '../components/CommonStyle'

const SimpleReservationStatusTag: React.FC<{editMode?: boolean, children?: ReactNode}> = props =>
    <StyledReservationStatus editMode={props.editMode}>{
        props.editMode ? '変更中' : props.children
    }</StyledReservationStatus>
SimpleReservationStatusTag.displayName = 'SimpleReservationStatusTag'
export default SimpleReservationStatusTag
